// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const OfficesList    = lazy(() => import('../../views/offices/list'))

const Offices = [
  {
    path: '/offices/list',
    element: <OfficesList />
  }
]

export default Offices
